export function PrintWeek({ appts, deliveries = [], start, end }) {
  const fmt = (iso) => new Date(iso + "T00:00").toLocaleDateString("it-IT", { weekday: "short", day: "2-digit", month: "2-digit" });
  const all = [...appts, ...deliveries.map((d) => ({ id: `d-${d.id}`, date: d.date, time: d.time_slot, client_name: `Consegna ${d.number}: ${d.customer_name}`, client_address: d.address, floor: d.floor_info, client_phone: d.phone }))];
  const rows = all.sort((a, b) => (a.date + (a.time || "99")).localeCompare(b.date + (b.time || "99")));
  return (
    <div className="print-area" data-testid="print-week">
      <h1 style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>Appuntamenti della settimana</h1>
      <p style={{ fontSize: 12, marginBottom: 12 }}>dal {fmt(start)} al {fmt(end)}</p>
      <table className="print-table">
        <thead>
          <tr><th>Data</th><th>Ora</th><th>Cliente</th><th>Indirizzo</th><th>Piano</th><th>Telefono</th></tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={6}>Nessun appuntamento in questa settimana</td></tr>}
          {rows.map((a) => (
            <tr key={a.id}>
              <td>{fmt(a.date)}</td>
              <td>{a.time || "—"}</td>
              <td>{a.client_name}</td>
              <td>{a.client_address}</td>
              <td>{a.floor}</td>
              <td>{a.client_phone}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
